'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../core/utils');

var _Highlighter = require('./Highlighter');

var _Highlighter2 = _interopRequireDefault(_Highlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = (0, _utils.createClassNames)('Highlight');

var Highlight = function Highlight(props) {
  return _react2.default.createElement(_Highlighter2.default, _extends({}, props, { highlightProperty: '_highlightResult', cx: cx }));
};

exports.default = Highlight;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/components/Highlight.js
// module id = 983
// module chunks = 142807904292071